// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__9tuMX","message":"style__message__bZbKK"};